import React from 'react';
import styles from './Features.module.css';

const Features = () => {
  const features = [
    {
      title: "Календарь на год с конкретными датами",
      description: "Дни запуска - благоприятные дни для начала важных проектов. Дни разрушителя - неблагоприятные дни, когда не стоит начинать важные дела. Финансовые указания по месяцам."
    },
    {
      title: "Опасные направления для путешествий",
      description: "Для каждого месяца будет указано, в какие направления нельзя путешествовать или возвращаться. Карта с визуализацией покажет вам, куда можно ехать безопасно."
    },
    {
      title: "Энергосберегающие месяцы",
      description: "Когда вы увидите в прогнозе пометку \"энергосберегающий режим\", это значит, что в этот месяц нужно бережно относиться к себе."
    },
    {
      title: "Практические инструменты",
      description: "Денежные часы - детальная инструкция о том, в какое время суток вам нужно совершать транзакции. Грабитель богатства - техника работы с определенными днями года."
    },
    {
      title: "Рекомендации по сферам жизни",
      description: "Здоровье, финансы, эмоциональное состояние. Все рекомендации персонализированы под вашу карту рождения."
    }
  ];

  return (
    <section className={styles.features}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          <span className="gold-text">Что входит в ваш персональный прогноз на 2026 год</span>
        </h2>
        <p className={styles.intro}>
          Ваш персональный прогноз по 9 Дворцам на 2026 год - это не просто документ. Это ваш персональный навигатор на весь год, содержащий все необходимые инструменты для успешного планирования.
        </p>
        <div className={styles.grid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.number}>{index + 1}</div>
              <h3 className={styles.title}>{feature.title}</h3>
              <p className={styles.description}>{feature.description}</p>
            </div>
          ))}
        </div>
        <div className={styles.imageWrapper}>
          <img 
            src="https://strategy.annavision.me/wp-content/uploads/2025/12/b8a5db223d9ec622d0e3c81b34dbc9ea_1766901996-1.png" 
            alt="Элегантный рабочий стол консультанта по 9 Дворцам" 
            className={styles.featureImage}
          />
        </div>
      </div>
    </section>
  );
};

export default Features;

